import { SvgBase } from "../svg.base";

export const AndroidLogo = () => (
    <SvgBase
        width="24"
        height="24"
        viewBox="0 0 24 30"
    >
        <defs>
            <filter id="nhy18fzgda">
                <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0" />
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g filter="url(#nhy18fzgda)" transform="translate(-1318 -378) translate(1240 374)">
                    <g>
                        <path d="M0 0L24 0 24 24 0 24z" transform="translate(78 4)" />
                        <path fill="#FFF" d="M6.11 17.59c0 .538.44.978.98.978h.983v3.42c0 .812.658 1.467 1.472 1.467.815 0 1.473-.655 1.473-1.466v-3.42h1.964v3.42c0 .81.658 1.466 1.473 1.466.814 0 1.472-.655 1.472-1.466v-3.42h.982c.54 0 .982-.44.982-.978V7.818H6.109v9.773zM3.654 7.819c-.815 0-1.473.655-1.473 1.466v6.841c0 .811.658 1.466 1.473 1.466.814 0 1.472-.655 1.472-1.466v-6.84c0-.812-.658-1.467-1.472-1.467zm16.69 0c-.814 0-1.472.655-1.472 1.466v6.841c0 .811.658 1.466 1.472 1.466.815 0 1.473-.655 1.473-1.466v-6.84c0-.812-.658-1.467-1.473-1.467zm-4.88-5.707L16.743.84c.197-.196.197-.499 0-.694-.196-.196-.5-.196-.697 0l-1.453 1.446c-.776-.391-1.66-.616-2.592-.616-.943 0-1.826.225-2.612.616L7.925.147c-.196-.196-.5-.196-.697 0-.196.195-.196.498 0 .693l1.287 1.28C7.06 3.187 6.109 4.897 6.109 6.84h11.782c0-1.944-.952-3.664-2.425-4.73zm-5.429 2.775h-.981V3.91h.981v.977zm4.91 0h-.982V3.91h.981v.977z" transform="translate(78 4)" />
                    </g>
                </g>
            </g>
        </g>
    </SvgBase>
);


